/* Alyssa's Cookies — homepage interactions */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Nav panel ---------- */
  var navToggle = document.getElementById("navToggle");
  var mainNav = document.getElementById("mainNav");

  var setNav = function (open) {
    mainNav.classList.toggle("open", open);
    navToggle.setAttribute("aria-expanded", String(open));
    navToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  };

  navToggle.addEventListener("click", function (e) {
    e.stopPropagation();
    setNav(!mainNav.classList.contains("open"));
  });

  mainNav.addEventListener("click", function (e) {
    if (e.target.tagName === "A") setNav(false);
  });

  /* Click anywhere outside the open panel closes it */
  document.addEventListener("click", function (e) {
    if (mainNav.classList.contains("open") && !mainNav.contains(e.target)) {
      setNav(false);
    }
  });

  /* Escape closes it too */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && mainNav.classList.contains("open")) setNav(false);
  });

  /* ---------- Back to top ---------- */
  var backToTop = document.getElementById("backToTop");
  if (backToTop) {
    var toggleTop = function () {
      backToTop.classList.toggle("show", window.scrollY > 600);
    };
    window.addEventListener("scroll", toggleTop, { passive: true });
    toggleTop();
    backToTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? "auto" : "smooth" });
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !reducedMotion) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- Section-appear triggers ----------
     Adds a class when the section scrolls into view: cookies fall into the Why
     section (once), and the comparison cards slide in from the sides (every
     time the section re-enters view, so `repeat: true` toggles on exit). */
  var appearTargets = [
    { sel: ".cuban", cls: "cuban-in", repeat: true },
    { sel: ".compare", cls: "compare-in", repeat: true }
    ];
  appearTargets.forEach(function (t) {
    var el = document.querySelector(t.sel);
    if (!el) return;
    if ("IntersectionObserver" in window && !reducedMotion) {
      var ao = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              el.classList.add(t.cls);
              if (!t.repeat) ao.unobserve(el);
            } else if (t.repeat) {
              el.classList.remove(t.cls);
            }
          });
        },
        { threshold: 0.2 }
      );
      ao.observe(el);
    } else {
      el.classList.add(t.cls);
    }
  });

  /* ---------- Reviews carousel ---------- */
  var track = document.getElementById("revTrack");
  var prevBtn = document.getElementById("revPrev");
  var nextBtn = document.getElementById("revNext");

  if (track && prevBtn && nextBtn) {
    var step = function () {
      var card = track.querySelector(".review-card");
      if (!card) return 340;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 22;
      return card.getBoundingClientRect().width + gap;
    };
    prevBtn.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: reducedMotion ? "auto" : "smooth" });
    });
    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: reducedMotion ? "auto" : "smooth" });
    });
  }

  /* ---------- Scroll parallax (decorative cookies) ---------- */
  var parallaxEls = document.querySelectorAll("[data-parallax]");
  if (parallaxEls.length && !reducedMotion) {
    var praf = null;
    var updateParallax = function () {
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var fromMid = (rect.top + rect.height / 2) - vh / 2;
        var speed = parseFloat(el.dataset.parallax) || 0.1;
        // set the individual `translate` property so it composes with the
        // element's CSS `rotate:` instead of overwriting it
        el.style.translate = "0 " + (-fromMid * speed).toFixed(1) + "px";
      });
      praf = null;
    };
    var onScrollParallax = function () {
      if (!praf) praf = requestAnimationFrame(updateParallax);
    };
    window.addEventListener("scroll", onScrollParallax, { passive: true });
    window.addEventListener("resize", onScrollParallax, { passive: true });
    updateParallax();
  }

  /* ---------- Hero pointer parallax ---------- */
  var heroArt = document.getElementById("heroArt");
  var finePointer = window.matchMedia("(pointer: fine)").matches;

  if (heroArt && finePointer && !reducedMotion) {
    var layers = heroArt.querySelectorAll(".parallax");
    var raf = null;
    var mx = 0, my = 0;

    heroArt.closest(".hero").addEventListener("pointermove", function (e) {
      var rect = heroArt.getBoundingClientRect();
      mx = (e.clientX - rect.left - rect.width / 2) / rect.width;
      my = (e.clientY - rect.top - rect.height / 2) / rect.height;
      if (!raf) {
        raf = requestAnimationFrame(function () {
          layers.forEach(function (layer) {
            var depth = parseFloat(layer.dataset.depth) || 20;
            layer.style.translate = mx * depth + "px " + my * depth + "px";
          });
          raf = null;
        });
      }
    });
  }

  /* ---------- Product detail: gallery + quantity ---------- */
  var pdpGallery = document.querySelector(".pdp-gallery");
  if (pdpGallery) {
    var pdpMainImg = pdpGallery.querySelector(".pdp-gallery__main span");
    var pdpThumbs = pdpGallery.querySelectorAll(".pdp-gallery__thumb");
    pdpThumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        pdpThumbs.forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
        if (pdpMainImg) pdpMainImg.style.backgroundImage = "url('" + thumb.dataset.img + "')";
      });
    });

    var ctaBtns = document.querySelectorAll(".pdp-cta[data-add]");

    var qtyBox = document.getElementById("pdpQty");
    if (qtyBox) {
      var qtyVal = qtyBox.querySelector("span");
      var setQty = function (n) {
        n = Math.max(1, n);
        qtyVal.textContent = String(n);
        ctaBtns.forEach(function (b) { b.setAttribute("data-qty", String(n)); });
      };
      qtyBox.querySelector("[data-inc]").addEventListener("click", function () {
        setQty(parseInt(qtyVal.textContent, 10) + 1);
      });
      qtyBox.querySelector("[data-dec]").addEventListener("click", function () {
        setQty(parseInt(qtyVal.textContent, 10) - 1);
      });
    }

    /* One-time vs subscribe: swaps the unit price fed to the cart */
    var purchaseOpts = document.querySelectorAll(".pdp-purchase__opt");
    if (purchaseOpts.length) {
      var pdpPriceEl = document.querySelector(".pdp-info__price");
      var syncPurchase = function () {
        purchaseOpts.forEach(function (opt) {
          if (!opt.querySelector("input").checked) return;
          var price = opt.getAttribute("data-price");
          ctaBtns.forEach(function (b) { b.setAttribute("data-price", price); });
          if (pdpPriceEl) pdpPriceEl.textContent = "$" + parseFloat(price).toFixed(2);
        });
      };
      purchaseOpts.forEach(function (opt) {
        opt.querySelector("input").addEventListener("change", syncPurchase);
      });
      syncPurchase();
    }
  }

  /* ---------- Newsletter (demo only) ---------- */
  var form = document.querySelector(".newsletter-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("button");
      var original = btn.textContent;
      btn.textContent = "✓ Signed Up!";
      btn.disabled = true;
      form.querySelector("input").value = "";
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 2600);
    });
  }
})();
